module.exports = __webpack_public_path__ + "img/game9.a727b549.png";